import { useState } from "react"
import Swal from "sweetalert2"
import { GET, POST, PUT, DELETE } from "../../../../services/api"
import { TableParams } from "../../dinamicPage/dinamyc-pages.types"
import { CreateLojaAgregadorDTO, LojaAgregador, UpdateLojaAgregadorDTO } from "../type"
import { validateForm } from "./aux-lojas-Agregado"

const URL = '/pluginspaceaggregator'

export function useLojasAgregador() {
    const [lojasAgregador, setLojasAgregador] = useState<LojaAgregador[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [tableLoading, setTableLoading] = useState<boolean>(false)

    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [10, 25, 50, 100],
    })
    const [sorting, setSorting] = useState({
        field: 'id',
        direction: 'asc' as 'asc' | 'desc',
    })
    const [searchTerm, setSearchTerm] = useState('')



    const handleDataChange = async (params: {
        page: number
        pageSize: number
        search: string
        sorting?: { field: string; direction: 'asc' | 'desc' }
        filters?: any
    }) => {
        setPagination((prev) => ({ ...prev, page: params.page, pageSize: params.pageSize }))
        if (params.sorting) setSorting(params.sorting)
        setSearchTerm(params.search)
        return await getLojasAgregador(params)
    }


    const handlePaginationChange = async (newPagination: any) => {
        setPagination(newPagination)
        return await getLojasAgregador({
            page: newPagination.page,
            pageSize: newPagination.pageSize,
            search: searchTerm,
            sorting: sorting.field ? sorting : { field: 'id', direction: 'asc' },
        })
    }

    const handleSortingChange = async (newSorting: any) => {
        setSorting(newSorting)
        return await getLojasAgregador({
            page: pagination.page,
            pageSize: pagination.pageSize,
            search: searchTerm,
            sorting: newSorting,
        })
    }

    async function getLojasAgregador(params?: TableParams) {
        try {
            setTableLoading(true)
            const currentPage = params?.page || pagination.page
            const currentPageSize = params?.pageSize || pagination.pageSize
            const currentSearch = params?.search || searchTerm
            const currentSorting = params?.sorting || sorting

            const query = `?field=${currentSorting.field}&order=${currentSorting.direction.toUpperCase()}&page=${currentPage}&take=${currentPageSize}&search=${currentSearch}`



            const request = await GET(`${URL}${query}`)
            console.log('[getAggregatorDinamicPage] Resposta da API:', request)
            if (!request.data) {
                console.warn('[getAggregatorDinamicPage] Nenhum dado retornado da API!')
            }

            setLojasAgregador(request.data)

            if (request.meta) {
                const paginagionInfo = {
                    total: request.meta.itemCount,
                    page: currentPage,
                    pageSize: currentPageSize,
                }
                setPagination((prev) => ({
                    ...prev,
                    ...paginagionInfo,
                }))
                console.log('[getLojasAgregado] Paginação atualizada:', paginagionInfo)
            }
            return request.data
        } catch (error) {
            console.log('[getLojasAgregado] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao filtrar',
            })
            return []
        } finally {
            setTableLoading(false)
        }
    }

    async function getLojasAgregadorById(id: number) {
        try {
            const request = await GET(`${URL}/${id}`)

            return request
        } catch (error) {
            console.log('[getLojasAgregado] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao filtrar',
            })
            return []
        } finally {
            setTableLoading(false)
        }
    }

    async function createLojasAgregador(data: CreateLojaAgregadorDTO):Promise<boolean> {
        try {

            const isValid = validateForm(data)
            if (!isValid) return false

            setLoading(true)
            const request = await POST(`${URL}`, data)
            console.log('[createAggregatorClassification] Resposta da API:', request)
            if (request.data) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    text: 'Página criada com sucesso!',
                })
                await getLojasAgregador()
            }
           return true
        } catch (error) {
            console.log('[createAggregatorClassification] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao criar a Página',
            })
            return false
        } finally {
            setLoading(false)
        }
    }

    async function updateLojaAgregador(id: number, data: UpdateLojaAgregadorDTO) {
        try {
            const isValid = validateForm(data as CreateLojaAgregadorDTO)
            if (!isValid) return
            setLoading(true)
            const request = await PUT(`${URL}/${id}`, data)
            console.log('[updateLojaAgregador] Resposta da API:', request)
            if (request.data) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    text: 'Página atualizada com sucesso!',
                })
                await getLojasAgregador()
            }
        } catch (error) {
            console.log('[updateLojaAgregador] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao atualizar a Página',
            })
        } finally {
            setLoading(false)
        }
    }

    async function deleteLojasAgregador(id: number) {
        try {
            setLoading(true)
            const request = await DELETE(`${URL}/${id}`)
            console.log('[deleteAggregatorClassification] Resposta da API:', request)
            if (request) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    text: 'Página deletada com sucesso!',
                })
                await getLojasAgregador()
            }
        } catch (error) {
            console.log('[deleteAggregatorClassification] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: error ?? 'Um erro ocorreu ao deletar a Página',
            })
        } finally {
            setLoading(false)
        }
    }

    return {
        lojasAgregador,
        loading,
        setLoading,
        tableLoading,
        pagination,
        sorting,
        searchTerm,
        handleDataChange,
        handlePaginationChange,
        handleSortingChange,
        setTableLoading,
        deleteLojasAgregador,
        updateLojaAgregador,
        createLojasAgregador,
        getLojasAgregadorById,
        getLojasAgregador
    }
}